import React from 'react';
import PaddingBox from '../../../../components/PaddingBox';
import classes from './styles/index.module.scss';

export const AuthenticationDescription = ({ children }) => {
	return (
		<PaddingBox bottomSmall>
			<div className={classes.authenticationTitle}>{children}</div>
		</PaddingBox>
	);
};
